import "./App.scss";
import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { LangContext } from "./context/langContext";
import Home from "./pages/Home/Home";
import Share from "./pages/Share/Share";
import NotFound from "./components/NotFound/NotFound";
import HomeLayout from "./components/HomeLayout/HomeLayout";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Terms from "./pages/Terms/Terms";
import swirl from "./assets/swirl.webp";
import swirlBottom from "./assets/swirl-bottom.webp";

function App() {
  const [lang, setLang] = useState("RU");
  const location = useLocation()

  const changeLang = (newLang) => {
    setLang(newLang[0]);
  };

  return (
    <LangContext.Provider value={lang}>
      <div className="app">
        <Routes>
          <Route path="/" element={<HomeLayout changeLang={changeLang} />} >
            <Route path="/" element={<Home />} />
            <Route path="/help/terms" element={<Terms />} />
            <Route path="/help/privacy" element={<PrivacyPolicy />} />
          </Route>
          <Route path="/share" element={<Share />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <img
          src={swirl}
          alt=""
          className="swirl-img"
          style={
            location.pathname === "/"
              ? { display: "block" }
              : { display: "none" }
          }
        />
        <img
          src={swirlBottom}
          alt=""
          className="swirl-img-bottom"
          style={
            location.pathname === "/"
              ? { display: "block" }
              : { display: "none" }
          }
        />
        <img
          src={swirl}
          alt=""
          className="swirl-img-404"
          style={
            location.pathname !== "/" && location.pathname !== "/help/terms" && location.pathname !== "/help/privacy"
              ? { display: "block" }
              : { display: "none" }
          }
        />
      </div>
    </LangContext.Provider>
  );
}

export default App;
